import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import IconOrderBy from '../../svg/IconOrderBy';

function ConnectedHeader({ values, style, isReady }) {
  return (
    <div className={`list-header`} style={style}>
      { values.map((x,i) => (
        <span key={`header${i}`} >
          <span onClick={(x.options && isReady) ? x.options.onClick : null} className={`list-header ${(x.options && isReady) ? `sortable` : null}`}>{x.value}</span>
          { (x.options && x.options.asc !== null) && <IconOrderBy asc={x.options.asc} /> }
          { (i + 1 !== values.length) ? <span> / </span> : null }
        </span>
      )) }
    </div>
  )
}

ConnectedHeader.propTypes = {
  values: PropTypes.array.isRequired,
  style: PropTypes.object,
}

const Header = connect(
  state => ({
    isReady: state.isReadyBoostFilters // To let the list completely load before filtering (Only Boost ON)
  })
)(ConnectedHeader);

export default Header;
